import React from 'react';
import PropTypes from 'prop-types';
import HoverButton from './HoverButton';
import ButtonBox from './ButtonBox';

export default class MemberButtonBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  highlight = (value) => {
    this.setState({ selected: value});
  }

  render() {
    return (
      <div>
        <ButtonBox classname={this.props.classname}
                   title="Members"
                   buttons={Array.from({ length: 18 }).map((_,i) => {
                     i+=1
                     return (
                       <HoverButton
                        key={i}
                        label={"Member " + i}
                        value={i < 10 ? "member_0" + i : "member_" + i}
                        onEvent={this.props.onEvent}
                        highlight={this.highlight}
                        selected={(i < 10 ? "member_0" + i : "member_" + i) === this.state.selected}
                     />
                   )})}
                   closable={true}/>
      </div>
    );
  }
}

MemberButtonBox.propTypes = {
  classname: PropTypes.string,
}
 



// WEBPACK FOOTER //
// ./src/MemberButtonBox.js